import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Equipo } from 'src/app/administracion/modelos/Inventario/Equipo/equipo';

@Component({
  selector: 'app-tabla-equipos',
  templateUrl: './tabla-equipos.component.html',
  styleUrls: ['./tabla-equipos.component.scss'],
})
export class TablaEquiposComponent {
  @Input() dataSource: MatTableDataSource<Equipo> =
    new MatTableDataSource<Equipo>([]);
  @Input() columnas: string[] = [];
  @Input() tituloEstatus: string = 'ESTADO ACTUAL';
  @Input() campoEstatus: string = 'states_id';
  @Input() tooltipEstatus: string = '';
  @Input() colorBoton: string = 'accent';
  @Input() estiloBoton: string = '';
  @Input() cargando: boolean = false;
  @Input() length: number = 0;
  @Input() pageIndex: number = 0;
  @Input() pageSize: number = 20;
  @Input() pageSizeOptions: number[] = [10, 20, 50, 100];

  @Output() verDetalle = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<PageEvent>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  filtroDataSource(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.paginator?.firstPage();
  }

  obtenerValorEstatus(element: Equipo): string {
    const valor = (element as any)[this.campoEstatus];
    return valor ?? '';
  }

  onVerDetalle(id_equipo: number) {
    this.verDetalle.emit(id_equipo);
  }

  onPage(event: PageEvent) {
    this.pageChange.emit(event);
  }
}
